import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Clipboard } from '@angular/cdk/clipboard';

@Injectable({
  providedIn: 'root'
})
export class ToolsService {

  constructor(private clipboard: Clipboard, private snack: MatSnackBar) { }

  copyToClipBoard(copy_value: string) {
    this.clipboard.copy(copy_value);
    this.snack.open(
      'Copied!',
      'Dismiss',
      { duration: 4000, panelClass: 'successSnackbar' }
    );
  }
}
